import React, { useState, useEffect } from "react";

import { Sidebar } from "primereact/sidebar";

import { FaChevronDown } from "react-icons/fa";
import Select, { components } from "react-select";
import { teamIds, teamList, userRole } from "../../../utils/storage";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FiCalendar } from "react-icons/fi";

const LeadFilterSidebar = ({
  visible,
  onHide,
  status,
  selectedStatus,
  handleStatusChange,
  interestLevel,
  selectedLevel,
  handleSelectChange,
  optionLocation,
  interestLocationTags,
  handleLocationChange,
  menuOpen,
  setMenuOpen,
  customStyles,
  getBackgroundClass,
  teams,
  selectedTeam,
  handleTeamChange,
  errors,
  users,
  DropdownIndicator,
  selectedUser,
  setSelectedUser,
  isLoading,
  startDate,
  setStartDate,
  startType,
  setStartType,
  endDate,
  setEndDate,
  filterHide = true,
  endType,
  setEndType,
  getLocalDate,
  handleApplyFilter,
  clearFilters,
}) => {
  const formatDisplayDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };

   const defaultTeamId =  Array.isArray(teamIds) && teamIds.length > 0 ? teamIds[0] : teamList;

  return (
    <Sidebar
      header={
        <div className="flex align-items-center gap-2">
          <span className="font-bold">Filter</span>
        </div>
      }
      visible={visible}
      onHide={onHide}
      position="right"
    >
      <div className="flex flex-col gap-4 p-4">
        <div className="flex flex-col items-center gap-5 w-full">
          {/* Status */}
          <div className="flex w-full items-center">
            <div className="flex  cursor-pointer w-full relative">
              <select
                className="appearance-none cursor-pointer  w-full shadow border-2 border-customGreen rounded-md py-2 px-3 text-gray-700"
                onChange={(e) => handleStatusChange(e.target.value)}
                value={selectedStatus}
              >
                <option value="">Select Status</option>
                {status.map((item, index) => (
                  <option key={index} value={item}>
                    {item}
                  </option>
                ))}
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-2 flex items-center px-2 text-customGreen">
                <FaChevronDown />
              </div>
            </div>
          </div>

          {/* Lead Quality */}
          <div className="w-full flex cursor-pointer items-center border-2 border-customGreen rounded-md shadow px-2 relative">
            <Select
              className="w-full  cursor-pointer appearance-none bg-transparent text-gray-700 focus:outline-none"
              value={selectedLevel}
              placeholder="Select Lead Quality"
              onChange={handleSelectChange}
              options={interestLevel}
              components={{ DropdownIndicator }}
              formatOptionLabel={(e) => (
                <div className="flex items-center">
                  <img src={e.image} alt={e.label} className="w-6 h-6 mr-2" />
                  <span className={`${getBackgroundClass(e.label)} font-bold`}>
                    {e.label}
                  </span>
                </div>
              )}
              styles={customStyles}
            />
          </div>

          {/* Location */}
          <div className="w-full flex items-center cursor-pointer border-2 border-customGreen rounded-md shadow px-2 relative">
            <Select
              className="w-full cursor-pointer text-gray-700"
              value={interestLocationTags}
              onChange={handleLocationChange}
              options={optionLocation}
              menuPlacement="bottom"
              onMenuOpen={() => setMenuOpen(true)}
              onMenuClose={() => setMenuOpen(false)}
              components={{ DropdownIndicator }}
              styles={customStyles}
              placeholder={
                errors.interestTags ? errors.interestTags : "Location"
              }
            />
          </div>

          {/* Team */}
          <div className="w-full cursor-pointer relative">
            <select
              className={`appearance-none cursor-pointer w-full shadow border-2 border-customGreen rounded-md py-2 px-3 text-gray-700 ${
                errors.teams && "border-red-500"
              }`}
              // disabled={defaultTeamId}
              disabled={userRole === "BOD" ? true : false}
              onChange={(e) => handleTeamChange(e.target.value)}
              value={selectedTeam}

            >
              <option value="">Select Team</option>
              {teams.map((item, index) => (
                <option key={index} value={item.teamId}>
                  {item.name}
                </option>
              ))}
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-2 flex items-center px-2 text-customGreen">
              <FaChevronDown />
            </div>
            {errors.teams && (
              <p className="text-red-500 text-xs mt-1">{errors.teams}</p>
            )}
          </div>

          {/* User */}
          <div className="w-full cursor-pointer relative">
            <select
              className={`appearance-none cursor-pointer w-full shadow border-2 border-customGreen rounded-md py-2 px-3 text-gray-700 ${
                errors.user && "border-red-500"
              }`}
              onChange={(e) => setSelectedUser(e.target.value)}
              value={selectedUser}
              disabled={!selectedTeam || isLoading}
            >
              <option value="">
                {isLoading
                  ? "Loading users..."
                  : !selectedTeam
                  ? "Select a team first"
                  : "Select User"}
              </option>
              {users.map((user, index) => (
                <option key={index} value={user.id}>
                  {user.name}
                </option>
              ))}
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-2 flex items-center px-2 text-customGreen">
              <FaChevronDown />
            </div>
            {errors.user && (
              <p className="text-red-500 text-xs mt-1">{errors.user}</p>
            )}
          </div>
          {filterHide && (
            <>
        {/* Start Date */}
        <div className="relative w-full">
          <DatePicker
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            placeholderText="Start Date"
            maxDate={new Date()}
            dateFormat="dd/MM/yyyy"
            className="w-full py-2 px-3 pr-52 border-2 border-customGreen rounded-md text-gray-700"
          />
          <FiCalendar className="absolute right-3 top-3 text-gray-500 pointer-events-none" />
        </div>

        {/* End Date */}
        <div className="relative w-full mt-3">
          <DatePicker
            selected={endDate}
            onChange={(date) => setEndDate(date)}
            placeholderText="End Date"
            minDate={startDate}
            maxDate={new Date()}
            dateFormat="dd/MM/yyyy"
            className="w-full py-2 px-3 pr-52 border-2 border-customGreen rounded-md text-gray-700"
          />
          <FiCalendar className="absolute right-3 top-3 text-gray-500 pointer-events-none" />
        </div>
      </>
          )}

          {/* Buttons */}
          <button
            className="bg-customGreen text-white py-2 px-4 rounded-md hover:bg-appGreenHover transition duration-300 w-full mt-4"
            onClick={handleApplyFilter}
          >
            Apply Filters
          </button>
          <button
            className="bg-white text-customGreen border border-customGreen py-2 px-4 rounded-md hover:bg-gray-100 transition duration-300 w-full"
            onClick={clearFilters}
          >
            Clear Filters
          </button>
        </div>
      </div>
    </Sidebar>
  );
};

export default LeadFilterSidebar;
